import { CSSProperties } from 'react';
import { useReduxState } from 'hooks';
import { getResizedImage } from 'shared-helpers/common';
import { Icon } from 'components/common/icons';

import type { CalendarEvent } from 'shared-types';

interface Props {
  picture: CalendarEvent['imageUrl'];
  size: number;
  style?: CSSProperties;
}

const CalendarEventTilePicture = ({ picture, size, style }: Props) => {
  const { theme } = useReduxState();

  return (
    <div
      className="picture"
      style={{
        ...(picture && {
          backgroundImage: `url(${getResizedImage({ url: picture, size })})`
        }),
        ...style
      }}
    >
      {!picture && (
        <div className="inner">
          <div className="icon">
            <Icon icon={['far', 'calendar-days']} />
          </div>
        </div>
      )}

      <style jsx>{`
        .picture {
          background-position: center;
          background-size: cover;
          border-radius: ${theme.cardBorderRadius};
          position: relative;
          height: 80px;
          width: 100%;
          background-color: ${theme.lightGrey};
        }
        .inner {
          align-items: center;
          display: flex;
          justify-content: center;
          height: 100%;
        }
        .icon {
          align-items: center;
          background-color: white;
          border-radius: 40px;
          color: ${theme.textColorLight};
          display: inline-flex;
          font-size: 2rem;
          justify-content: center;
          height: 40px;
          width: 40px;
        }
      `}</style>
    </div>
  );
};

export default CalendarEventTilePicture;
